import React from 'react'

export default function VerticalDivider() {
  return (
    <div className='verticalDivider' ></div>
  )
}
